import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { OtherVersionComponent } from './other-version.component';

@Component({
  selector: 'other-version-desktop',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './other-version-desktop.component.html',
})
export class OtherVersionDesktopComponent
  extends OtherVersionComponent
  implements OnInit
{
  @Output() otherVersionClicked = new EventEmitter<boolean>();

  constructor() {
    super();
  }

  ngOnInit() {}

  onOtherVersionClicked() {
    this.otherVersionClicked.emit(true);
  }
}
